import { render, staticRenderFns } from "./tujuan_sasaran.vue?vue&type=template&id=62da7db8&"
import script from "./tujuan_sasaran.vue?vue&type=script&lang=js&"
export * from "./tujuan_sasaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports